import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import React from 'react';

export interface IProps {
  name: string;
  value: boolean;
  onChange?: (event: any) => void;
  isReadonly: boolean;
}

const CheckBox = (props: IProps) => {
  return (
    <Checkbox
      name={props.name}
      readOnly={props.isReadonly}
      icon={<CheckBoxOutlineBlankIcon fontSize="inherit" />}
      checkedIcon={<CheckBoxIcon fontSize="inherit" />}
      checked={props.value}
      onChange={props.onChange}
      sx={{
        padding: 0,
        color: 'white',
        '&.Mui-checked': {
          color: '#0d83c9',
        },
      }}
    />
  );
};

export default CheckBox;
